import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import api from '@/lib/api';
import Header from '@/components/storefront/Header';
import Footer from '@/components/storefront/Footer';
import { Helmet } from 'react-helmet-async';

export default function PolicyPage() {
  const { slug: paramSlug } = useParams();
  const location = window.location.pathname;
  const slug = paramSlug || location.replace(/^\//, '');
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/pages/${slug}`).then(r => { setPage(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, [slug]);

  if (loading) return (
    <div className="min-h-screen" style={{ backgroundColor: '#FDFBF7' }}>
      <Header />
      <div className="max-w-3xl mx-auto px-6 py-20 text-center font-sans text-sm" style={{ color: 'rgba(26,26,26,0.4)' }}>Loading...</div>
    </div>
  );

  if (!page) return (
    <div className="min-h-screen" style={{ backgroundColor: '#FDFBF7' }}>
      <Header />
      <div className="max-w-3xl mx-auto px-6 py-20 text-center font-sans text-lg" style={{ color: 'rgba(26,26,26,0.4)' }}>Page not found</div>
      <Footer />
    </div>
  );

  return (
    <div data-testid={`page-${slug}`} className="min-h-screen" style={{ backgroundColor: '#FDFBF7' }}>
      <Helmet>
        <title>{`${page.title} | Florashop`}</title>
        <meta name="description" content={page.meta_description || page.title} />
      </Helmet>
      <Header />
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}
        className="max-w-3xl mx-auto px-6 md:px-12 py-12">
        <article className="font-sans text-sm leading-relaxed prose max-w-none
          [&_h2]:font-serif [&_h2]:text-2xl [&_h2]:tracking-tight [&_h2]:mb-4 [&_h2]:mt-8 [&_h2]:text-[#1A1A1A]
          [&_h3]:font-sans [&_h3]:text-base [&_h3]:font-medium [&_h3]:mb-2 [&_h3]:mt-6 [&_h3]:text-[#1A1A1A]
          [&_p]:mb-3 [&_p]:text-[rgba(26,26,26,0.7)] [&_p]:leading-relaxed
          [&_ul]:mb-3 [&_ul]:pl-5 [&_li]:mb-1 [&_li]:text-[rgba(26,26,26,0.7)]
          [&_ol]:mb-3 [&_ol]:pl-5
          [&_a]:text-[#E85D3A] [&_a]:underline [&_a]:underline-offset-2
          [&_strong]:text-[#1A1A1A]"
          dangerouslySetInnerHTML={{ __html: page.content }}
        />
      </motion.div>
      <Footer />
    </div>
  );
}
